import SessionExpiredDialog from "./SessionExpiredDialog.container";

export default SessionExpiredDialog;
